export default function safeWindowOpen(url: string): void {
  window.open(url, '_blank', 'noopener, noreferrer');
}
